<template>
  
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Hello ' + this.$store.state.world,
      model: {}
    }
  },
  methods: {
    saveProduct () {
      productsRef.push(this.model);
      this.clear();
       
    },
    clear () {
      this.model = {}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/HelloWorld.vue